import { useLazyQuery } from "@apollo/client";
import { Button } from "../../../../components/ui";
import { FETCH_CONSIGNMENT_WORKS as fetchConsignmentWorks } from "../../../../graphql/query/ConsignmentWork";

const CopyDescription = ({ closeModal, consignmentId }) => {
  const [fetchConsignmentWorksDescriptions, { loading }] = useLazyQuery(
    fetchConsignmentWorks({
      artistNames: false,
      consignment: false,
      instance: {
        description: true,
      },
    }),
  );

  const handleCopyDescription = async () => {
    const { data } = await fetchConsignmentWorksDescriptions({
      variables: {
        input: {
          limit: 50,
          offset: 0,
          consignmentId: consignmentId,
        },
      },
    });
    const descriptions = data?.consignmentWorks?.edges
      ?.map(consignmentWork => consignmentWork?.instance?.description)
      .join("\n");
    await navigator.clipboard.writeText(descriptions);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        autoFocus
        disabled={loading}
        label={"Copy description"}
        onClick={handleCopyDescription}
      />
    </div>
  );
};

export default CopyDescription;
